export const RANGE_VIEW = {
    id: "1-range",
    name: "Kitchen Stovetop",
    levels: [
        {
            tileSize: 256,
            size: 256,
            fallbackOnly: true,
        },
        {
            tileSize: 512,
            size: 512,
        },
        {
            tileSize: 512,
            size: 1024,
        },
        {
            tileSize: 512,
            size: 2048,
        },
    ],
    faceSize: 2048,
    initialViewParameters: {
        yaw: -0.3168408305503547,
        pitch: 0.4112538247743842,
        fov: 1.403086486818207,
    },
    linkHotspots: [
        {
            yaw: -1.4723537063451513,
            pitch: 0.5733203109624494,
            rotation: 13.351768777756625,
            target: "3-nook",
        },
        {
            yaw: -2.290368877444294,
            pitch: 0.20382900302229245,
            rotation: 6.283185307179586,
            target: "4-prep",
        },
        {
            yaw: -2.929058461756574,
            pitch: 0.14890333642543752,
            rotation: 5.497787143782138,
            target: "5-dining",
        },
        {
            yaw: 2.999421917176713,
            pitch: 0.16526212984214972,
            rotation: 2.356194490192345,
            target: "2-island",
        },
        {
            yaw: 1.8616691744690872,
            pitch: 0.18966662182902638,
            rotation: 15.707963267948973,
            target: "0-init",
        },
    ],
    infoHotspots: [
        {
            yaw: 0.1762612427263015,
            pitch: 0.03423226765445975,
            title: `Olive Oils`,
            subhead: `Olive Oils`,
            text: `
    <ul>
      <span class="title">Basil-Infused Olive Oil</span>
      <li>
        <b>#100647</b>
      </li>
      <li>
        <b>USD</b>
        $20 |
        <b>CAD</b>
        $26
      </li>
      <li>Gluten-Free, Kosher</li>
      <li>8 fl. oz. (236 mL)</li>
      <li>
        This high-quality olive oil is infused with a peppery and slightly sweet
        flavor of basil.
      </li>
      <li>
        <b>Great for:</b>
        a cooking base to building flavors in protein, veggies, and pasta
        dishes. And, it makes a delicious dressing or bread dipper.
      </li>
      <span class="title">Garlic-Parmesan Olive Oil</span>
      <li><b>#100648</b></li>
      <li>
        <b>USD</b>
        $21 |
        <b>CAD</b>
        $27
      </li>
      <li>Gluten-Free | Contains milk.</li>
      <li>8 fl. oz. (236 mL)</li>
      <li>
        This high-quality olive oil has a rich flavor with bits of garlic and
        Parmesan cheese.
      </li>
      <li>
        <b>Great for:</b>
        a cooking base to building flavors in protein, veggies, and pasta
        dishes. And, it makes a delicious dressing or bread dipper.
      </li>
    </ul>
  `,
            images: [
                `<img width="640" alt="olive-oil-01.jpeg" src="https://pamperedchef.widen.net/content/0jfzet1qf7/jpeg/olive-oil-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="olive-oil-02.jpeg" src="https://pamperedchef.widen.net/content/kuypbgvqbm/jpeg/olive-oil-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="olive-oil-03.jpeg" src="https://pamperedchef.widen.net/content/tju25hryiv/jpeg/olive-oil-03.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
            ],
        },
        {
            yaw: 0.06378553289168742,
            pitch: 0.42189483122553284,
            title: `Oil &amp; Vinegar Dispenser`,
            subhead: `Oil &amp; Vinegar Dispenser`,
            text: `
    <ul>
      <li><b>#100670</b></li>
      <li>
        <b>USD</b>
        $35 |
        <b>CAD</b>
        $45
      </li>
      <li>3-year guarantee</li>
      <li>Dishwasher-safe: bottle and measuring cup | Hand wash: straw</li>
      <li>7¼" x 2¾" (18.5 cm x 7 cm)</li>
      <li>
        When your recipe needs a precise amount of oil or vinegar, but you don't
        want to grab another measuring spoon, this handy dispenser makes it easy
        to measure and pour just what you need.
      </li>
      <li>
        The spout lets you add oil or vinegar to recipes with precision, while
        the pump top lets you measure the amount.
      </li>
      <li>
        Press the button to fill the attached measuring cup to the teaspoons or
        milliliters you want and pour.
      </li>
      <li>
        The glass bottle won't stain or absorb odors or flavors, making it easy
        to switch between different flavored oils or types of vinegar.
      </li>
      <li>
        <b>Great for:</b>
        cooking, dressing a salad, and more.
      </li>
    </ul>
  `,
            images: [
                `<img width="640" alt="dispenser-01.jpeg" src="https://pamperedchef.widen.net/content/tcrb4oz1du/jpeg/dispenser-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="dispenser-02.jpeg" src="https://pamperedchef.widen.net/content/lrjvh9gw33/jpeg/dispenser-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="dispenser-03.jpeg" src="https://pamperedchef.widen.net/content/rieymitnja/jpeg/dispenser-03.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
            ],
            videos: [
                `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/j99zu6b1xo/video-product-oil-and-vinegar-dispenser-demo-usca.mp4" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
            ],
        },
  //       {
  //           yaw: -0.3783919489461365,
  //           pitch: 0.7243957198098485,
  //           title: `Mix ‘N Chop™ Spatula`,
  //           subhead: `Mix ‘N Chop™ Spatula`,
  //           text: `
  //   <ul>
  //     <li><b>#100676</b></li>
  //     <li>
  //       <b>USD</b>
  //       $18 |
  //       <b>CAD</b>
  //       $24
  //     </li>
  //     <li>3-year guarantee </li>
  //     <li>Dishwasher-safe | Heat-safe to 450°F (230°C)</li>
  //     <li>11¼" (28.5 cm) long</li>
  //     <li>Chop, drain, scoop, and serve all from one tool.</li>
  //     <li>Durable nylon core head for chopping and scooping food.</li>
  //     <li>
  //       Silicone outer layer is safe to use on all cookware surfaces and loved
  //       for its durability, heat resistance, and slip resistance.
  //     </li>
  //     <li>
  //       Ergonomic soft-grip handle with thumb rest is comfortable to hold.
  //     </li>
  //     <li>
  //       It has a curved design for the rocking and chopping motion you need to
  //       crumble and brown ground beef, turkey, and sausage.
  //     </li>
  //     <li>
  //       It has a spatula area and drain holes to scoop ground meat out of grease
  //       and serve it easily.
  //     </li>
  //     <li>
  //       <b>Great for:</b>
  //       ground meat, avocadoes, eggs, crushed tomatoes, and more.
  //     </li>
  //     <li>
  //       Also in the
  //       <b>Taco Night Set:</b>
  //       Tortilla Warmer, Guacamole Mix, Chipotle Rub, and Mix 'N Chop™ Spatula.
  //     </li>
  //   </ul>
  // `,
  //           images: [
  //               `<img width="640" alt="mix-chop-spatula-01.jpeg" src="https://pamperedchef.widen.net/content/gibbepxtog/jpeg/mix-chop-spatula-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
  //               `<img width="640" alt="mix-chop-spatula-02.jpeg" src="https://pamperedchef.widen.net/content/ksbvmzzasy/jpeg/mix-chop-spatula-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
  //               `<img width="640" alt="mix-chop-spatula-03.jpeg" src="https://pamperedchef.widen.net/content/wofmczjonj/jpeg/mix-chop-spatula-03.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
  //               `<img width="640" alt="mix-chop-spatula-04.jpeg" src="https://pamperedchef.widen.net/content/cetcwdkr3e/jpeg/mix-chop-spatula-04.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
  //           ],
  //           videos: [
  //               `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/d6oeruy0wn/video-product-mix-n-chop-spatula-usca.mp4" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
  //           ],
  //       },
        {
            yaw: -0.5549176142764232,
            pitch: 0.34615184964177814,
            title: `Stainless Steel Nonstick Skillet`,
            subhead: `8.5" (22-cm) Stainless Steel Nonstick Skillet`,
            text: `
    <ul id="single_product">
      <li><b>#100664</b></li>
      <li>
        <b>USD</b>
        $125 |
        <b>CAD</b>
        $150
      </li>
      <li>Lifetime guarantee</li>
      <li>Dishwasher-safe | Induction-safe | PFOA-free</li>
      <li>
        Pans is heat-safe to 450°F (220°C) | Glass lid is heat-safe to 400°F
        (200°C)
      </li>
      <li>
        This innovative pan combines the best features of stainless steel and
        nonstick cookware. Its nonstick mesh coating provides the perfect sear
        (without the mess) and leaves fond for pan sauces and gravy.
      </li>
      <li>Tri-ply clad for durability and faster, more even heating.</li>
      <li>Designed without rivets for easier cleaning</li>
      <li>Use your favorite utensils—even metal!</li>
      <li>
        Flared rims make pouring easy and keep stovetops and counters free of
        drips.
      </li>
      <li>
        <b>Great for:</b> dinner for two, smaller servings, delicious sides.
      </li>
      <li>
       Other pans in the <b>Stainless Steel Nonstick Cookware Collection:</b><br/>
         <div style="width: 100%; height: 6px"></div>
         &nbsp;• 10" (25-cm) Stainless Steel Nonstick Skillet<br/>
         <div style="width: 100%; height: 6px"></div>
         &nbsp;• 12" (30-cm) Stainless Steel Nonstick Skillet<br/>
         <div style="width: 100%; height: 6px"></div>
         &nbsp;• Stainless Steel Nonstick Wok
      </li>
    </ul>
  `,
            images: [
                `<img height="640" alt="8.5-stainless-skillet-01.jpeg" src="https://pamperedchef.widen.net/content/izuuaxffq2/jpeg/8.5-stainless-skillet-01.jpeg?h=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img height="640" alt="8.5-stainless-skillet-01.jpeg" src="https://pamperedchef.widen.net/content/kjlvkw5knp/jpeg/8.5-stainless-skillet-02.jpeg?h=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img height="640" alt="8.5-stainless-skillet-03.jpeg" src="https://pamperedchef.widen.net/content/o8iaeiqpeh/jpeg/8.5-stainless-skillet-03.jpeg?h=640&keep=c&crop=yes&color=cccccc&quality=80">`,
            ],
            videos: [
                `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/f2x2ldjdp1/video-product-stainless-steel-nonstick-cookware-collection-short-clip-usca.mp4" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
            ],
        },
    ],
};
